/**
 * Shared constants for the Post-Completion tab + dashboards.
 *
 * Lives in one place so adding a new workflow kind (e.g. SDLT5 amendment,
 * Companies House LL01) only requires touching this file rather than
 * grepping 5 components.
 */
import {
  Stamp,
  Bank,
  Buildings,
  HouseLine,
  EnvelopeOpen,
} from "@phosphor-icons/react";

export const KIND_META = {
  sdlt: {
    label: "SDLT Return",
    provider: "HMRC Stamp Taxes Online",
    icon: Stamp,
    color: "text-amber-700",
    deadlineCopy: "14 calendar days from completion",
  },
  ap1: {
    label: "AP1 — Land Registry",
    provider: "HMLR Business Gateway",
    icon: Buildings,
    color: "text-indigo-700",
    deadlineCopy: "Within OS1 priority period (~30 working days)",
  },
  mr01: {
    label: "MR01 — Charge Registration",
    provider: "Companies House Filings",
    icon: Bank,
    color: "text-violet-700",
    deadlineCopy: "21 calendar days from charge creation",
  },
  redemption: {
    label: "Mortgage Redemption",
    provider: "Lender confirmation",
    icon: HouseLine,
    color: "text-emerald-700",
    deadlineCopy: "Chase letter ~7 days post-completion",
  },
  leasehold_notice: {
    label: "Notice of Transfer / Charge",
    provider: "Freeholder / Management Co.",
    icon: EnvelopeOpen,
    color: "text-rose-700",
    deadlineCopy: "Usually within 30 days (check lease)",
  },
};

export const STATUS_OPTIONS = [
  { value: "not_started", label: "Not started" },
  { value: "in_progress", label: "In progress" },
  { value: "submitted", label: "Submitted" },
  { value: "requisition", label: "Requisition raised" },
  { value: "completed", label: "Completed" },
  { value: "rejected", label: "Rejected" },
];
